// Static content for the Privacy Policy page.
// Kept as plain data (instead of PageBuilder / hosted assets) so the page
// no longer depends on a fetched "privacy-policy" page asset.

export const companyInfo = {
  name: 'Metta People Ltd (Thailand)',
  registrationLabelId: 'PrivacyPolicyPage.companyRegistrationLabel',
  registrationNumber: '0105567098617',
};

// Block types used below:
// p        -> paragraph
// ul       -> bullet list
// box      -> bordered sub-section box (titleId + body)
// kvTable  -> two-column label/value table
// contact  -> contact cards, { cards: [{ headingId, rows: [{ labelId?, value }] }] }

export const privacySections = [
  {
    number: '1',
    titleId: 'PrivacyPolicyPage.s1.title',
    accentBar: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s1.b1',
      },
      {
        type: 'ul',
        itemIds: ['PrivacyPolicyPage.s1.li1', 'PrivacyPolicyPage.s1.li2'],
      },
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s1.b2',
      },
    ],
  },
  {
    number: '2',
    titleId: 'PrivacyPolicyPage.s3.title',
    gradient: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s3.b1',
      },
    ],
  },
  {
    number: '3',
    titleId: 'PrivacyPolicyPage.s4.title',
    blocks: [
      {
        type: 'ol',
        itemIds: [
          'PrivacyPolicyPage.s4.li1',
          'PrivacyPolicyPage.s4.li2',
          'PrivacyPolicyPage.s4.li3',
          'PrivacyPolicyPage.s4.li4',
          'PrivacyPolicyPage.s4.li5',
        ],
      },
    ],
  },
  {
    number: '4',
    titleId: 'PrivacyPolicyPage.s5.title',
    gradient: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s5.b1',
      },
    ],
  },
  {
    number: '5',
    titleId: 'PrivacyPolicyPage.s6.title',
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s6.b1',
      },
    ],
  },
  {
    number: '6',
    titleId: 'PrivacyPolicyPage.s7.title',
    accentBar: true,
    blocks: [
      {
        type: 'kvTable',
        rows: [
          ['PrivacyPolicyPage.s7.r1.label', 'PrivacyPolicyPage.s7.r1.value'],
          ['PrivacyPolicyPage.s7.r2.label', 'PrivacyPolicyPage.s7.r2.value'],
          ['PrivacyPolicyPage.s7.r3.label', 'PrivacyPolicyPage.s7.r3.value'],
        ],
      },
    ],
  },
  {
    number: '7',
    titleId: 'PrivacyPolicyPage.s8.title',
    gradient: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s8.b1',
      },
      {
        type: 'ul',
        itemIds: [
          'PrivacyPolicyPage.s8.li1',
          'PrivacyPolicyPage.s8.li2',
          'PrivacyPolicyPage.s8.li3',
          'PrivacyPolicyPage.s8.li4',
        ],
      },
    ],
  },
  {
    number: '8',
    titleId: 'PrivacyPolicyPage.s9.title',
    accentBar: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s9.b1',
      },
    ],
  },
  {
    number: '9',
    titleId: 'PrivacyPolicyPage.s10.title',
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s10.b1',
      },
    ],
  },
  {
    number: '10',
    titleId: 'PrivacyPolicyPage.s11.title',
    gradient: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s11.b1',
      },
    ],
  },
  {
    number: '11',
    titleId: 'PrivacyPolicyPage.s12.title',
    accentBar: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s12.b1',
      },
    ],
  },
  {
    number: '12',
    titleId: 'PrivacyPolicyPage.s13.title',
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s13.b1',
      },
      {
        type: 'box',
        titleId: 'PrivacyPolicyPage.s13.box1.title',
        bodyId: 'PrivacyPolicyPage.s13.box1.body',
      },
      {
        type: 'box',
        titleId: 'PrivacyPolicyPage.s13.box2.title',
        bodyId: 'PrivacyPolicyPage.s13.box2.body',
      },
      {
        type: 'box',
        titleId: 'PrivacyPolicyPage.s13.box3.title',
        bodyId: 'PrivacyPolicyPage.s13.box3.body',
      },
    ],
  },
  {
    number: '13',
    titleId: 'PrivacyPolicyPage.s14.title',
    accentBar: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s14.b1',
      },
    ],
  },
  {
    number: '14',
    titleId: 'PrivacyPolicyPage.s15.title',
    gradient: true,
    blocks: [
      {
        type: 'p',
        id: 'PrivacyPolicyPage.s15.b1',
      },
    ],
  },
  {
    number: '15',
    titleId: 'PrivacyPolicyPage.s16.title',
    blocks: [
      {
        type: 'contact',
        cards: [
          {
            headingId: 'PrivacyPolicyPage.s16.card1.heading',
            rows: [{ value: 'Metta People Ltd (Thailand)' }],
          },
          {
            headingId: 'PrivacyPolicyPage.s16.card2.heading',
            rows: [{ value: 'Data Protection Officer' }],
          },
          {
            headingId: 'PrivacyPolicyPage.s16.card3.heading',
            rows: [{ value: 'info@mettapeople.com' }],
          },
          {
            headingId: 'PrivacyPolicyPage.s16.card4.heading',
            rows: [
              {
                value:
                  '41/1, Soi On Nut 36, On Nut Sub-district, Suan Luang District, Bangkok 10250, Thailand',
              },
            ],
          },
        ],
      },
    ],
  },
];
